<template>
    <v-container>
        <v-layout row wrap >
            <v-flex xs12 md2 ma-1>
                <v-text-field
                    v-model="firstname"
                    label="Nombre "
                    @keyup="applyFilters"
                
                ></v-text-field>                
            </v-flex>

            <v-flex xs12 md2 ma-1>
                <v-text-field
                    v-model="lastname"
                    label="Apellido"
                    @keyup="applyFilters"
                
                ></v-text-field>
            </v-flex>

            <v-flex xs12 md3 ma-1>
                <v-text-field
                    v-model="document"
                    label="Documento"
                    @keyup="applyFilters"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 ma-1>
                <v-text-field
                    v-model="email"
                    label="Email"
                    @keyup="applyFilters"
                ></v-text-field>
            </v-flex>
            
        </v-layout>
    </v-container>
    
    </template>
    <script>
    
    export default {
        name: "AptosFiltros",
        props: {
            evento_id: {
                type: Number,
                default: null 
            }  
        },
        data() {
            return {
                timeout: null,
                query: '',
                document: '',
                filters: {
                    firstname: '',
                    lastname: '',
                    document: '',
                    email: ''
                } 
            }
        },
        mounted() {
        },
        methods: {
         
            applyFilters: function() {
                this.filters.firstname = this.firstname;
                this.filters.lastname = this.lastname;
                this.filters.document = this.document;         
                this.filters.email = this.email;
    
                clearTimeout(this.timeout);            
                var self = this;
                this.timeout = setTimeout(function () {       
                    self.$emit('updateFilter', self.filters);
                }, 500);            
            },
    
            clearFilters() {
                
                this.filters = {
                    firstname: '',
                    lastname: '',
                    document: '',
                    email: ''
                };
                this.applyFilters();
            }
        }
    }
    </script>